import { createContext, useContext } from 'react';

import { useFeatureToggleConfig } from '../../../app-config/hooks/use-query/use-feature-toggle-config';
import { useIsChecklistAdminQuery } from '../../../app-config/hooks/use-query/use-is-checklist-admin-query';
import { useIsTemplateAdminQuery } from '../../../app-config/hooks/use-query/use-is-template-admin-query';
import { useSelectedRootLocationConfiguration } from '../../../app-config/hooks/use-selected-root-location-configuration';
import { useIsLocationEnabledForFeatureFlag } from '../../../feature-flags/location-toggles/use-is-location-enabled-for-feature-flag';

export interface IsSchedulerEnabledContextInterface {
  useSelectedRootLocationConfiguration: typeof useSelectedRootLocationConfiguration;
  useIsChecklistAdminQuery: typeof useIsChecklistAdminQuery;
  useIsTemplateAdminQuery: typeof useIsTemplateAdminQuery;
  useFeatureToggleConfig: typeof useFeatureToggleConfig;
  useIsLocationEnabledForFeatureFlag: typeof useIsLocationEnabledForFeatureFlag;
}

export const IsSchedulerEnabledContext =
  createContext<IsSchedulerEnabledContextInterface>({
    useSelectedRootLocationConfiguration,
    useIsChecklistAdminQuery,
    useIsTemplateAdminQuery,
    useFeatureToggleConfig,
    useIsLocationEnabledForFeatureFlag,
  });

export const useIsSchedulerEnabledContext = () => {
  return useContext(IsSchedulerEnabledContext);
};
